import { GenericBackendResponse } from '../genericBackendResponse';
import { GenericPaginationOutput } from '../generic-dtos/genericPaginationOutput';

export enum BonusStatusType {
	PENDING = 'PENDING',
	DECIDED = 'DECIDED',
	EXECUTED = 'EXECUTED',
	EXPIRED = 'EXPIRED'
}

export enum BonusGroupType {
	QUARTERLY = 'QUARTERLY',
	SEMIANNUAL = 'SEMIANNUAL',
	MONTHLY = 'MONTHLY'
}

export interface ExtraordinaryBonus {
	id: string;
	createdAt: string;
	updatedAt: string;
	userId: string;
	companyId?: string;
	periodStart: string;
	periodEnd: string;
	amount: number;
	decisionDeadline: string;
	decisionAmount?: number;
	decisionPercentage?: number;
	decisionAt?: string;
	status: BonusStatusType;
	executedAt?: string;
	promoterContribution?: number;
	participantContribution?: number;
	groupType?: BonusGroupType;
	data?: Record<string, any>;
}

export interface UserBonusesOutputDto {
	bonuses: ExtraordinaryBonus[];
	totalCount: number;
}

export interface CompanyBonusWithUserDto {
	bonus: ExtraordinaryBonus;
	userName: string;
	userEmail: string;
}

export interface CompanyBonusesOutputDto {
	bonuses: CompanyBonusWithUserDto[];
	totalCount: number;
	companyId: string;
}

export interface BonusConfig {
	startBonusDate: Date;
	endBonusDate: Date;
	bonusAmount: number;
	deadline: Date;
	maxSelectable: number;
}

export const getAllBonuses = async (
	token: string
): Promise<GenericBackendResponse<UserBonusesOutputDto>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/extraordinary-bonuses/get-all-bonuses`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const result = await response.json();
	return result;
};

export const getAllCompanyBonuses = async (
	token: string,
	companyId: string,
	page: number,
	limit: number,
	month?: number,
	quarter?: number
): Promise<GenericBackendResponse<GenericPaginationOutput<CompanyBonusWithUserDto>>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/extraordinary-bonuses/get-all-company-bonuses/${companyId}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({
				page,
				limit,
				...(month && { month }),
				...(quarter && { quarter })
			})
		}
	);

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const result = await response.json();
	return result;
};

export const convertBonusToConfig = (bonus: ExtraordinaryBonus): BonusConfig => {
	return {
		startBonusDate: new Date(bonus.periodStart),
		endBonusDate: new Date(bonus.periodEnd),
		bonusAmount: bonus.amount,
		deadline: new Date(bonus.decisionDeadline),
		maxSelectable: bonus.amount
	};
};
